import { createSlice } from "@reduxjs/toolkit";
import { isEmpty } from "../utils/utils";

const initialState = {
  onboardingId: null,
  token: null,
  lang: "en",
  backUrl: null,
  isOnboardedWithEmail: false,
  email: null,
  firstName: null,
  lastName: null,
  dateOfBirth: null,
  currentStep: null,
  company: null,
  error: null,
  isLegalAgreementAccepted: false,
  isVOPChecked: false,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    initParams: (state, action) => {
      const { onboardingId, token } = action.payload;
      if (!isEmpty(onboardingId) && !isEmpty(token)) {
        return {
          ...initialState,
          lang: state.lang,
          onboardingId,
          token,
        };
      }
    },
    setWorkflow: (state, action) => {
      state.backUrl = action.payload.backUrl;
      state.isOnboardedWithEmail = action.payload.isOnboardedWithEmail;
      state.email = action.payload.email;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.dateOfBirth = action.payload.dateOfBirth;
      state.currentStep = action.payload.currentStep?.name;
      state.company = action.payload.company;
    },
    setLanguage: (state, action) => {
      state.lang = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    updateStore: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});
export const {
  initParams,
  setLanguage,
  setError,
  setWorkflow,
  setCompany,
  updateStore,
} = appSlice.actions;

export default appSlice.reducer;
